import type { WasmExportConfig } from "../types/WasmExportConfig"
import { BuildFSImports as build_imports } from "../filesystem/browser/BuildFSImports"

/** Config that wires up MemFS syscall/WASI imports for modules needing file I/O. */
export const FileSystem: Partial<WasmExportConfig> = {
  build_imports,
}
